var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"title":"联系客服","visible":_vm.dialogVisible,"width":"400px"},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('div',{staticClass:"customer_service_box"},[_c('img',{staticClass:"customer_service_img",attrs:{"src":"https://ai-ewg1990.oss-cn-guangzhou.aliyuncs.com/20250218/xianrui.jpg","alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }